<template>
    <div>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>

        <div class="row">
            <div class="d-none d-lg-block col-lg-2"></div>
            <div class="col-12 col-lg-8">
                <h1>User Management</h1>
                <p>This page allows you to create, update, delete, and ban individual users. The user's district status 
                    can be managed from the <a href='/#/admin/dist-users'>District User Management</a> page.</p>
                <div class="list-group">
                    <div v-for="(u, idx) in users" class="list-group-item" :class="warnUser ? 'warn-user' : ''">

                        <admin-user-manage-form
                            v-if="editing == u.id"
                            :value="u"
                            :all-districts="allDistricts"
                            @cancel="editing = -1"
                            @input="updated(idx, $event)"
                            >
                        </admin-user-manage-form>
                        <admin-user-manage-row v-else :value="u" @delete="remove" @edit="edit"></admin-user-manage-row>
                    </div>
                    <div class="list-group-item d-flex">
                        <admin-user-manage-form
                            :all-districts="allDistricts"
                            ref="newUser"
                            @input="created"
                        ></admin-user-manage-form>
                    </div>
                </div>
                <div class="mt-4">
                    <home-button></home-button>
                </div>

            </div>
        </div>
    </div>
</template>

<style></style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import AdminUserManageForm from "./AdminUserManageForm.vue";
import AdminUserManageRow from "./AdminUserManageRow.vue";
import HomeButton from "./HomeButton";

export default {
    components: { 
        Loading,
        AdminUserManageForm,
        AdminUserManageRow,
        HomeButton,
    },

    props: {
        user: {
            type: Object,
            required: false
        }
    },

    mounted() {
        this.isLoading = true;
        axios
            .get('/api/admin/users')
            .then((response) => {
                this.users = response.data;
            })
            .catch(error => {
                console.error(error);
            });

        axios
            .get('/api/admin/districts')
            .then((response) => { 
                this.allDistricts = response.data;
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    computed: {
        warnUser: function() {
            return false;
            //return Boolean(user.status == 1 && user.districts.length == 0);
        },
    },

    data() {
        return {
            isLoading: false,
            users: [],
            editing: -1,
            allDistricts: []
        };
    },

    methods: {
        created: function(event) {
            this.users.push(event);
            this.$refs.newUser.clear();
        },

        edit: function(event) {
            this.editing = event;
        },

        remove: function(event) {
            this.users.filter(user => user.id != event);
        },

        updated: function(index, event) {
            this.users[index] = event;
            this.editing = -1;
        },
    }
}
</script>

<style scoped>
.warn-user {
    background: MistyRose;
}
</style>